import React from "react";
import Loadable from "react-loadable";
import Loading from "./components/Loading";
const Index = Loadable({
  loader: () => import("./pages/Index"),
  loading: () => <Loading />,
});
const Invite = Loadable({
  loader: () => import("./pages/Invite"),
  loading: () => <Loading />,
});
const List = Loadable({
  loader: () => import("./pages/List"),
  loading: () => <Loading />,
});
const Reward = Loadable({
  loader: () => import("./pages/Reward"),
  loading: () => <Loading />,
});
const AccountLevel = Loadable({
  loader: () => import("./pages/AccountLevel"),
  loading: () => <Loading />,
});
const AccountUpgrade = Loadable({
  loader: () => import("./pages/AccountUpgrade"),
  loading: () => <Loading />,
});
const AccountUpRes = Loadable({
  loader: () => import("./pages/AccountUpRes"),
  loading: () => <Loading />,
});

const VIPFee = Loadable({
  loader: () => import("./pages/VIPFee"),
  loading: () => <Loading />,
});

const Bonus = Loadable({
  loader: () => import("./pages/Bonus"),
  loading: () => <Loading />,
});

const NotFound = Loadable({
  loader: () => import("./pages/notFound"),
  loading: () => <Loading />,
});

const SlideCaptcha = Loadable({
  loader: () => import("./pages/slide-captcha"),
  loading: () => <Loading />,
});

const Online = Loadable({
  loader: () => import("./pages/Online"),
  loading: () => <Loading />,
});

const Lottery = Loadable({
  loader: () => import("./pages/lottery"),
  loading: () => <Loading />,
});

const Retained = Loadable({
  loader: () => import("./pages/Retained"),
  loading: () => <Loading />,
});

const Rebate = Loadable({
  loader: () => import("./pages/Rebate"),
  loading: () => <Loading />,
});

export default [
  // 
  {
    path: "/:lang/rebate",
    component: Rebate,
    exact: true,
  },
  {
    path: "/:lang/invite", //邀请返佣页面
    exact: true,
    component: Invite,
  },
  {
    path: "/:lang/list", //邀请好友
    exact: true,
    component: List,
  },
  {
    path: "/:lang/reward", //邀请记录，返佣记录
    exact: true,
    component: Reward,
  },

  {
    path: "/:lang/upgrade", //账户升级页面
    component: AccountUpgrade,
    exact: true,
  },

  {
    path: "/:lang/accountLevel", //账户等级介绍页面
    component: AccountLevel,
    exact: true,
  },
  {
    path: "/:lang/upgradeResult", //账户等级介绍结果页面
    component: AccountUpRes,
    exact: true,
  },
  {
    path: "/:lang/vip-fee", //交易费用
    component: VIPFee,
    exact: true,
  },
  {
    path: "/:lang/bonus", //累积赠金活动
    component: Bonus,
    exact: true,
  },

  {
    path: "/:lang/slide-captcha",
    component: SlideCaptcha,
    exact: true,
  },
  {
    path: "/:lang/online",
    component: Online,
    exact: true,
  },
  {
    path: "/:lang/lottery", //抽奖
    component: Lottery,
    exact: true,
  },
  {
    path: "/:lang/10daysevent", //10日留存活动
    component: Retained,
    exact: true,
  },
  {
    path: "/:lang",
    component: Index,
    exact: true,
  },
  {
    path: "*",
    component: NotFound,
  },
];



// WEBPACK FOOTER //
// ./src/routes.js